export function getData(state) {
  return state.data;
}

export function getPagination(state) {
  return state.pagination;
}